(function() {
  'use strict';

  function ReportWrapperService() {
    var service = {};
    return service;
  }

  ReportWrapperService.$inject = [];

  angular.module('component.reports')
    .factory('ReportWrapperService', ReportWrapperService);
})();
